<div class="modal fade" id="kt_modal_add_update_deposit" tabindex="-1" aria-hidden="true">
	<div class="modal-dialog modal-dialog-centered mw-1000px">
		<div class="modal-content">
			<div class="modal-header p-3 d-flex justify-content-between bg-secondary">
				<h2 class="fw-bold m-0">{{ isEditMode ? 'Update Deposit' : 'Add Deposit' }}</h2>
				<div class="btn btn-icon btn-sm btn-active-icon-primary" data-bs-dismiss="modal">
					<i class="ki-duotone ki-cross fs-1">
						<span class="path1"></span>
						<span class="path2"></span>
					</i>
				</div>
			</div>
			<form [formGroup]="depositForm" (ngSubmit)="onSubmit()" novalidate>
				<div class="modal-body p-5">
					<div class="d-flex flex-column scroll-y p-3" data-kt-scroll="true" data-kt-scroll-activate="true" data-kt-scroll-max-height="auto" data-kt-scroll-wrappers="#kt_modal_add_update_deposit_scroll" data-kt-scroll-offset="300px">

						<!-- Alert for allocated amount -->
						<div *ngIf="hasAllocatedAmount" class="alert alert-info d-flex align-items-center p-3 mb-5">
							<i class="ki-duotone ki-information-5 fs-2hx text-info me-3">
								<span class="path1"></span>
								<span class="path2"></span>
								<span class="path3"></span>
							</i>
							<div class="d-flex flex-column">
								<h5 class="mb-1">Limited Editing Mode</h5>
								<span class="fs-7">This deposit has allocated amounts. Only specific fields can be edited.</span>
							</div>
						</div>

						<div class="row">
							<!-- Reference Number -->
							<div class="col-md-4 mb-5">
								<label for="reference_number" class="form-label fs-7 fw-semibold mb-2">Ref #</label>
								<input type="text" formControlName="reference_number" id="reference_number" class="form-control form-control-sm" />
							</div>

							<!-- Payment Type -->
							<div class="col-md-4 mb-5">
								<label for="payment_type" class="form-label fs-7 fw-semibold mb-2">Payment Type <span class="required"></span></label>
								<select formControlName="payment_type" id="payment_type" class="form-select form-select-sm"
									[class.is-invalid]="depositForm.get('payment_type')?.invalid && depositForm.get('payment_type')?.touched">
									<option value="" disabled>Select Type</option>
									<option *ngFor="let type of paymentTypes" [value]="type.name">{{ type.name }}</option>
								</select>
								<div class="invalid-feedback" *ngIf="depositForm.get('payment_type')?.invalid && depositForm.get('payment_type')?.touched">
									<div *ngIf="depositForm.get('payment_type')?.errors?.['required']">Payment Type is required</div>
								</div>
							</div>

							<!-- Customer Name (Searchable) -->
							<div class="col-md-4 mb-5">
								<label for="customer_name" class="form-label fs-7 fw-semibold mb-2">Customer Name <span class="required"></span></label>
								<div class="position-relative">
									<input
										type="text"
										id="customer_name"
										class="form-control form-control-sm"
										[class.is-invalid]="depositForm.get('customer_name')?.invalid && depositForm.get('customer_name')?.touched"
										placeholder="Search Customer"
										[(ngModel)]="customerSearchTerm"
										(input)="onCustomerSearchInput($event)"
										(focus)="onCustomerInputFocus()"
										(blur)="onCustomerInputBlur()"
										[ngModelOptions]="{standalone: true}"
										[disabled]="hasAllocatedAmount"
										autocomplete="off" />

									<!-- Loading Spinner -->
									<div *ngIf="isCustomerSearching" class="position-absolute top-50 end-0 translate-middle-y me-3">
										<span class="spinner-border spinner-border-sm text-primary" role="status" aria-hidden="true"></span>
									</div>

									<!-- Clear Button -->
									<div *ngIf="customerSearchTerm && !isCustomerSearching && !hasAllocatedAmount" class="position-absolute top-50 end-0 translate-middle-y">
										<button type="button" class="btn btn-sm btn-icon btn-light-danger" (click)="clearCustomerSearch()" title="Clear">
											<i class="ki-duotone ki-cross fs-6">
												<span class="path1"></span>
												<span class="path2"></span>
											</i>
										</button>
									</div>

									<!-- Dropdown Results -->
									<div *ngIf="showCustomerDropdown" class="dropdown-menu show position-absolute w-100 mt-1 shadow-sm border" style="z-index: 1050; max-height: 300px; overflow-y: auto;">
										<div *ngIf="customerSearchResults.length === 0 && !isCustomerSearching" class="dropdown-item-text text-muted text-center py-3">
											No customers found
										</div>
										<a
											*ngFor="let customer of customerSearchResults"
											href="javascript:void(0)"
											class="dropdown-item d-flex align-items-center py-2"
											(click)="selectCustomer(customer)">
											<div class="d-flex flex-column">
												<span class="fw-bold text-gray-800">{{ getCustomerDisplayName(customer) }}</span>
												<small class="text-muted" *ngIf="customer.email">{{ customer.email }}</small>
												<small class="text-muted" *ngIf="customer.city || customer.country">
													{{ customer.city }}{{ customer.city && customer.country ? ', ' : '' }}{{ customer.country }}
												</small>
											</div>
										</a>
									</div>

									<!-- Validation Error Message -->
									<div *ngIf="depositForm.get('customer_name')?.invalid && depositForm.get('customer_name')?.touched" class="invalid-feedback d-block">
										<div *ngIf="depositForm.get('customer_name')?.errors?.['required']">Customer Name is required</div>
									</div>
								</div>
							</div>
						</div>

						<div class="row">
							<!-- Agent Name (Auto-filled, Disabled) -->
							<div class="col-md-4 mb-5">
								<label for="agent_name" class="form-label fs-7 fw-semibold mb-2">Agent Name</label>
								<input type="text" formControlName="agent_name" id="agent_name" class="form-control form-control-sm" />
							</div>

							<!-- Bank -->
							<div class="col-md-4 mb-5">
								<label for="bank" class="form-label fs-7 fw-semibold mb-2">Bank <span class="required"></span></label>
								<select formControlName="bank" id="bank" class="form-select form-select-sm"
									[class.is-invalid]="depositForm.get('bank')?.invalid && depositForm.get('bank')?.touched">
									<option value="" disabled>Select Bank</option>
									<option *ngFor="let bank of banks" [value]="bank.name">{{ bank.name }}</option>
								</select>
								<div class="invalid-feedback" *ngIf="depositForm.get('bank')?.invalid && depositForm.get('bank')?.touched">
									<div *ngIf="depositForm.get('bank')?.errors?.['required']">Bank is required</div>
								</div>
							</div>

							<!-- Received Date -->
							<div class="col-md-4 mb-5">
								<label for="received_date" class="form-label fs-7 fw-semibold mb-2">Received Date <span class="required"></span></label>
								<input type="date" formControlName="received_date" id="received_date" class="form-control form-control-sm"
									[class.is-invalid]="depositForm.get('received_date')?.invalid && depositForm.get('received_date')?.touched" />
								<div class="invalid-feedback" *ngIf="depositForm.get('received_date')?.invalid && depositForm.get('received_date')?.touched">
									<div *ngIf="depositForm.get('received_date')?.errors?.['required']">Received Date is required</div>
								</div>
							</div>
						</div>

						<div class="row">
							<!-- Received Amount -->
							<div class="col-md-4 mb-5">
								<label for="received_amount" class="form-label fs-7 fw-semibold mb-2">Received Amount <span class="required"></span></label>
								<div class="input-group">
									<input type="number" formControlName="received_amount" id="received_amount" class="form-control form-control-sm"
										[class.is-invalid]="depositForm.get('received_amount')?.invalid && depositForm.get('received_amount')?.touched" />
									<span class="input-group-text" *ngIf="currencyType">{{currencyType.toUpperCase()}}</span>
								</div>
								<div class="invalid-feedback" *ngIf="depositForm.get('received_amount')?.invalid && depositForm.get('received_amount')?.touched">
									<div *ngIf="depositForm.get('received_amount')?.errors?.['required']">Received Amount is required</div>
									<div *ngIf="depositForm.get('received_amount')?.errors?.['min']">Amount must be greater than or equal to 0</div>
								</div>
							</div>

							<!-- Depositor Name -->
							<div class="col-md-4 mb-5">
								<label for="depositor_name" class="form-label fs-7 fw-semibold mb-2">Depositor Name</label>
								<input type="text" formControlName="depositor_name" id="depositor_name" class="form-control form-control-sm" />
							</div>

							<!-- Chassis No -->
							<div class="col-md-4 mb-5">
								<label for="chassis_no" class="form-label fs-7 fw-semibold mb-2">Chassis #</label>
								<input type="text" formControlName="chassis_no" id="chassis_no" class="form-control form-control-sm" />
							</div>
						</div>

						<div class="row">
							<!-- Admin Comment -->
							<div class="col-md-12 mb-5">
								<label for="admin_comment" class="form-label fs-7 fw-semibold mb-2">Admin Comment ({{ getAdminCommentLength() }}/ 250)</label>
								<textarea formControlName="admin_comment" id="admin_comment" class="form-control form-control-sm" rows="3"
									[class.is-invalid]="depositForm.get('admin_comment')?.invalid && depositForm.get('admin_comment')?.touched"></textarea>
								<div class="invalid-feedback" *ngIf="depositForm.get('admin_comment')?.invalid && depositForm.get('admin_comment')?.touched">
									<div *ngIf="depositForm.get('admin_comment')?.errors?.['maxlength']">Admin Comment cannot exceed 250 characters</div>
								</div>
							</div>
						</div>

						<div class="row">
							<!-- Refund Amount -->
							<div class="col-md-4 mb-5">
								<label for="refund_amount" class="form-label fs-7 fw-semibold mb-2">Refund Amount</label>
								<input type="number" formControlName="refund_amount" id="refund_amount" class="form-control form-control-sm"
									[class.is-invalid]="depositForm.get('refund_amount')?.invalid && depositForm.get('refund_amount')?.touched" />
								<div class="invalid-feedback" *ngIf="depositForm.get('refund_amount')?.invalid && depositForm.get('refund_amount')?.touched">
									<div *ngIf="depositForm.get('refund_amount')?.errors?.['min']">Amount must be greater than or equal to 0</div>
								</div>
							</div>

							<!-- Refund Date -->
							<div class="col-md-4 mb-5">
								<label for="refund_date" class="form-label fs-7 fw-semibold mb-2">Refund Date</label>
								<input type="date" formControlName="refund_date" id="refund_date" class="form-control form-control-sm" />
							</div>

							<!-- Balance Amount -->
							<div class="col-md-4 mb-5">
								<label for="balance_amount" class="form-label fs-7 fw-semibold mb-2">
									{{ hasAllocatedAmount ? 'Remaining Amount' : 'Balance Amount' }}
									<span *ngIf="hasAllocatedAmount" class="badge badge-light-info fs-9 ms-1">Read-only</span>
								</label>
								<div class="input-group">
									<input type="number" formControlName="balance_amount" id="balance_amount" class="form-control form-control-sm"
										[class.is-invalid]="depositForm.get('balance_amount')?.invalid && depositForm.get('balance_amount')?.touched"
										[readonly]="hasAllocatedAmount" />
									<span class="input-group-text" *ngIf="currencyType && hasAllocatedAmount">{{currencyType.toUpperCase()}}</span>
								</div>
								<div class="invalid-feedback" *ngIf="depositForm.get('balance_amount')?.invalid && depositForm.get('balance_amount')?.touched">
									<div *ngIf="depositForm.get('balance_amount')?.errors?.['min']">Amount must be greater than or equal to 0</div>
								</div>
							</div>
						</div>

						<div class="row">
							<!-- R.Rate -->
							<div class="col-md-4 mb-5">
								<label for="r_rate" class="form-label fs-7 fw-semibold mb-2">R.Rate</label>
								<input type="text" formControlName="r_rate" id="r_rate" class="form-control form-control-sm" />
							</div>

							<div class="col-md-4 mb-5">
								<label for="ex_rate" class="form-label fs-7 fw-semibold mb-2">Ex.Rate</label>
								<input type="text" formControlName="ex_rate" id="ex_rate" class="form-control form-control-sm" />
							</div>

							<!-- Incoming TT Copy -->
							<div class="col-md-4 mb-5">
								<label for="incoming_tt_copy" class="form-label fs-7 fw-semibold mb-2">Incoming TT Copy</label>
								<input type="file"
									(change)="onIncomingTTCopyChange($event)"
									id="incoming_tt_copy"
									class="form-control form-control-sm"
									[disabled]="isUploadingIncomingTT"
									accept="image/*,.pdf,.doc,.docx" />

								<!-- Upload Progress -->
								<div *ngIf="isUploadingIncomingTT" class="d-flex align-items-center mt-2">
									<div class="spinner-border spinner-border-sm me-2" role="status">
										<span class="visually-hidden">Uploading...</span>
									</div>
									<span class="text-muted fs-8">Uploading file...</span>
								</div>

								<!-- Uploaded File Link -->
								<div *ngIf="incomingTTCopyUrl && !isUploadingIncomingTT" class="mt-2">
									<a [href]="incomingTTCopyUrl" target="_blank" class="btn btn-sm btn-light-primary">
										<i class="ki-duotone ki-file fs-6">
											<span class="path1"></span>
											<span class="path2"></span>
										</i>
										View File
									</a>
								</div>
							</div>

							<!-- Customer TT Copy -->
							<div class="col-md-4 mb-5">
								<label for="customer_tt_copy" class="form-label fs-7 fw-semibold mb-2">Customer TT Copy</label>
								<input type="file"
									(change)="onCustomerTTCopyChange($event)"
									id="customer_tt_copy"
									class="form-control form-control-sm"
									[disabled]="isUploadingCustomerTT"
									accept="image/*,.pdf,.doc,.docx" />

								<!-- Upload Progress -->
								<div *ngIf="isUploadingCustomerTT" class="d-flex align-items-center mt-2">
									<div class="spinner-border spinner-border-sm me-2" role="status">
										<span class="visually-hidden">Uploading...</span>
									</div>
									<span class="text-muted fs-8">Uploading file...</span>
								</div>

								<!-- Uploaded File Link -->
								<div *ngIf="customerTTCopyUrl && !isUploadingCustomerTT" class="mt-2">
									<a [href]="customerTTCopyUrl" target="_blank" class="btn btn-sm btn-light-primary">
										<i class="ki-duotone ki-file fs-6">
											<span class="path1"></span>
											<span class="path2"></span>
										</i>
										View File
									</a>
								</div>
							</div>
						</div>

					</div>
				</div>
				<div class="modal-footer p-3">
					<button type="button" class="btn btn-sm btn-light me-3" data-bs-dismiss="modal">Cancel</button>
					<button type="submit" class="btn btn-sm btn-primary indicator" style="min-width: 100px;" [disabled]="depositForm.invalid || isLoading">
						<span class="indicator-label" *ngIf="!isLoading">{{ isEditMode ? 'Update' : 'Add' }}</span>
						<span class="indicator-progress" *ngIf="isLoading">
							<span class="spinner-border spinner-border-sm align-middle me-2"></span>
							Please wait...
						</span>
					</button>
				</div>
			</form>
		</div>
	</div>
</div>
